import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';
import { App as AntApp, ConfigProvider } from 'antd';
import { StyleProvider } from '@ant-design/cssinjs';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';

const ThemeWrapper = ({ children }) => {
  const { theme } = useTheme();

  return (
    <ConfigProvider theme={theme}>
      {children}
    </ConfigProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StyleProvider hashPriority="high">
      <ThemeProvider>
        <ThemeWrapper>
          <AntApp>
            <App />
          </AntApp>
        </ThemeWrapper>
      </ThemeProvider>
    </StyleProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
